import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
import * as styles from "./ColumnsPanel.module.scss";
import { GeneralSizeKeyToPaddingNumber  } from "../../../utils/datasources"

const ColumnsPanelThreeColumn = ({ blok }) => {
  const headerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.header_padding_top),
        headerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.header_padding_bottom),
        footerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.footer_padding_top),
        footerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.footer_padding_bottom)
        const textColor = blok.text_color && blok.text_color === 'white' ? '#fff' : null;
  return (
    <PanelWrapper blok={blok}>
      {blok.show_header ? (
        <div className={styles.header_span} style={{paddingTop: headerPaddingTop, paddingBottom: headerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.header_text)} style={textColor ? {color:textColor} : null}
          ></div>
        </div>
      ) : null}
      <Container>
        <Row>
          <Col xs={12} sm={4}>
            <div dangerouslySetInnerHTML={resolveRichText(blok.column_1)} style={textColor ? {color:textColor} : null}></div>
          </Col>
          <Col xs={12} sm={4}>
            <div dangerouslySetInnerHTML={resolveRichText(blok.column_2)} style={textColor ? {color:textColor} : null}></div>
          </Col>
          <Col xs={12} sm={4}>
            <div dangerouslySetInnerHTML={resolveRichText(blok.column_3)} style={textColor ? {color:textColor} : null}></div>
          </Col>
        </Row>
      </Container>

      {blok.show_footer ? (
        <div className={styles.footer_span} style={{paddingTop: footerPaddingTop, paddingBottom: footerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.footer_text)} style={textColor ? {color:textColor} : null}
          ></div>
        </div>
      ) : null}
    </PanelWrapper>
  );
};

export default ColumnsPanelThreeColumn;
